import { Box, Typography, Grid, Container } from '@mui/material';
import PrimerDownload from './PrimerDownload';
import {underdogPrinciples} from '../../utils/bookdata';

const PrinciplesIntro = () => {

  return (
    <Box id="principles" sx={{ 
      backgroundColor: 'warning.main', // Uses theme yellow color
      py: 8,
      position: 'relative',
      overflow: 'hidden'
    }}>
      <Container maxWidth="lg">
        <Typography 
          variant="h2" 
          align="center"
          sx={{ 
            color: 'warning.contrastText', // Uses theme black text on yellow
            fontWeight: 'bold',
            mb: 6,
            position: 'relative',
         }}
        >
          The <Box 
            component="span" 
            sx={{ 
              color: 'secondary.main', // Uses theme red color
              fontFamily: 'Permanent Marker', 
              fontWeight: 100, 
              fontSize: '55px' 
            }}
          >
            Underdog
          </Box> Principles
        </Typography>
        
        <Grid container spacing={4}>
          {underdogPrinciples.map((principle) => (
            <Grid size={{xs: 12, md: 4}} key={principle.id}>
              <Box sx={{
                backgroundColor: 'background.paper', // Uses theme white
                p: 3,
                borderRadius: 2,
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '6px',
                  backgroundColor: 'secondary.main', // Uses theme red
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                }
             }}>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  mb: 3
                }}>
                  <Box 
                    component="img"
                    src={principle.image}
                    alt={principle.alt}
                    sx={{ 
                      width: 60, 
                      height: 60,
                      mr: 2
                    }}
                  />
                  <Typography
                    variant="h3"
                    sx={{
                      fontFamily: 'Permanent Marker',
                      color: 'secondary.main', // Uses theme red
                      fontSize: { xs: '1.5rem', md: '1.75rem' }
                    }}
                  >
                    {principle.title}
                  </Typography>
                </Box>
                
                <Typography 
                  variant="body1" 
                  sx={{ 
                    mb: 3,
                    fontSize: '1.1rem',
                    fontWeight: 500,
                    color: 'text.primary' // Uses theme black text
                  }}
                >
                  {principle.sentence}
                </Typography>
                
                <Typography 
                  variant="body2"
                  sx={{
                    color: 'text.secondary', // Uses theme gray text
                    flex: 1,
                    mb: 2
                  }}
                >
                  {principle.explainer}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
        
        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <Typography 
            variant="h5" 
            component="p"
            sx={{ 
              mb: 3,
              fontWeight: 500,
              maxWidth: '700px',
              mx: 'auto',
              color: 'warning.contrastText' // Uses theme black text on yellow
            }}
          >
            Want to learn more about how these principles can transform your business?
          </Typography>
          <PrimerDownload buttonText="Get The Primer" fullWidth={false} />
        </Box>
      </Container>
      
      {/* Design elements with theme colors */}
      <Box sx={{
        position: 'absolute',
        bottom: -100,
        right: -80,
        width: '200px',
        height: '200px',
        backgroundColor: (theme) => theme.palette.secondary.main + '1A', // Red with 10% opacity
        borderRadius: '50%',
        zIndex: 0
      }} />
      
      <Box sx={{
        position: 'absolute',
        top: -50,
        left: -80,
        width: '180px',
        height: '180px',
        backgroundColor: (theme) => theme.palette.secondary.main + '0D', // Red with 5% opacity
        borderRadius: '50%',
        zIndex: 0
      }} />
    </Box>
  );
};

export default PrinciplesIntro;